import { render, staticRenderFns } from "./PublicationLauncher.vue?vue&type=template&id=7b51ce3f&scoped=true&"
import script from "./PublicationLauncher.vue?vue&type=script&lang=js&"
export * from "./PublicationLauncher.vue?vue&type=script&lang=js&"
import style0 from "./PublicationLauncher.vue?vue&type=style&index=0&id=7b51ce3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51ce3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VRow})
